module.exports = __webpack_public_path__ + "img/logo.d806fc23.png";